import ConnectedReusable from "../../../ComponentLibrary/WIP/ConnectedReusable"
import { CONTENT_AND_IMAGE_REUSABLE } from "./constants"

// this reusable is a content and image, it goes on applicable PDPs, under the color accuracy banner
const ColorSamplesContentAndImage = () => <ConnectedReusable {...CONTENT_AND_IMAGE_REUSABLE} />

export default ColorSamplesContentAndImage
